import React from "react";

export interface DimensionModel {
    width: number;
    height: number;
    innerWidth: number;
    innerHeight: number;

    minWidth(minWidth: number): boolean;
    maxWidth(maxWidth: number): boolean;
}

const makeDimension = ({
    width,
    height,
    innerWidth,
    innerHeight,
}: {
    width: number;
    height: number;
    innerWidth: number;
    innerHeight: number;
}): DimensionModel => ({
    width,
    height,
    innerWidth,
    innerHeight,
    minWidth: (min) => width >= min,
    maxWidth: (max) => width < max,
});

export function useElementDimensions(ref: React.RefObject<HTMLDivElement>) {
    const [dimensions, setDimensions] = React.useState(
        makeDimension({ width: 0, height: 0, innerWidth: 0, innerHeight: 0 }),
    );

    React.useEffect(() => {
        function calcDimensions() {
            const page = ref.current;
            if (page) {
                const width = page.offsetWidth;
                const height = page.offsetHeight;

                const cs = window.getComputedStyle(page);
                const hpadding = parseInt(cs.paddingLeft, 10) + parseInt(cs.paddingRight, 10);
                const vpadding = parseInt(cs.paddingTop, 10) + parseInt(cs.paddingBottom, 10);
                const innerWidth = page.offsetWidth - hpadding;
                const innerHeight = page.offsetHeight - vpadding;

                if (dimensions.width !== width || dimensions.height !== height)
                    setDimensions(makeDimension({ width, height, innerWidth, innerHeight }));
            }
        }

        window.addEventListener("resize", calcDimensions);
        const interval = window.setInterval(calcDimensions, 200);
        calcDimensions();

        return () => {
            window.removeEventListener("resize", calcDimensions);
            window.clearInterval(interval);
        };
    }, [ref, dimensions]);

    return dimensions;
}
